import React, { useEffect, useState, createElement } from 'react';
import { Calendar, Lock, AlertTriangle, X, MousePointerClick, Download, Mail, MessageCircle } from 'lucide-react';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
export function ThankYouMPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  // Function to get next Tuesday date (for /meta-martes traffic)
  const getNextTuesday = () => {
    const now = new Date();
    // Convert to EST timezone
    const estTime = new Date(now.toLocaleString('en-US', {
      timeZone: 'America/New_York'
    }));
    const currentDay = estTime.getDay(); // 0 = Sunday, 2 = Tuesday
    const currentHour = estTime.getHours();
    let daysUntilTuesday = 0;
    if (currentDay === 2) {
      // It's Tuesday
      if (currentHour >= 19) {
        // After 7pm EST, show next week's Tuesday
        daysUntilTuesday = 7;
      } else {
        // Before 7pm EST, show today
        daysUntilTuesday = 0;
      }
    } else if (currentDay < 2) {
      // Before Tuesday this week (Sunday=0, Monday=1)
      daysUntilTuesday = 2 - currentDay;
    } else {
      // After Tuesday (Wednesday=3, Thursday=4, Friday=5, Saturday=6)
      daysUntilTuesday = 7 - currentDay + 2;
    }
    const nextTuesday = new Date(estTime);
    nextTuesday.setDate(estTime.getDate() + daysUntilTuesday);
    const day = nextTuesday.getDate();
    return day;
  };
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('init', '4285913388317138');
    window.fbq('track', 'PageView');
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/nrxtdp5ht5.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    // Add Wistia player styles
    const style = document.createElement('style');
    style.textContent = `
      wistia-player[media-id='nrxtdp5ht5']:not(:defined) { 
        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/nrxtdp5ht5/swatch'); 
        display: block; 
        filter: blur(5px); 
        padding-top:56.25%; 
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(playerScript);
      document.head.removeChild(embedScript);
      document.head.removeChild(style);
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-4936" data-mp="384y97t6wck6h">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-4937" data-mp="337euyta787ej">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-4938" data-mp="336wqxahaoow2" />
      </noscript>

      {/* Cyan Header Banner - Tuesday date */}
      <div className="bg-gradient-to-r from-[#00f7fc] to-[#00d7dc] py-3 md:py-5 px-4" data-id="element-4939" data-mp="2taa9yws3ahzb">
        <div className="max-w-4xl mx-auto text-center" data-id="element-4940" data-mp="2p8ymoxwou8ua">
          <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-4941" data-mp="3dyjhzl2bnoss">
            <Calendar className="w-5 h-5 md:w-7 md:h-7 text-black" data-id="element-4942" data-mp="3ix4h1h5u82fn" />
            <h1 className="text-xs sm:text-sm md:text-lg lg:text-xl font-bold whitespace-nowrap text-black tracking-tight" data-id="element-4943" data-mp="3iyfkffvdf868">
              Reservada La Fecha: Martes {getNextTuesday()} | 7PM EST (Hora
              Miami)
            </h1>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main className="max-w-6xl mx-auto px-4 py-6 md:py-10" data-id="element-4944" data-mp="3063lz47u8r1d">
        {/* Main Headline */}
        <div className="text-center mb-6 md:mb-10" data-id="element-4945" data-mp="303qvu3rxfad8">
          <div className="mb-3" data-id="element-4946" data-mp="2m7dlrfpq2b8s">
            <div className="inline-flex items-center gap-2 bg-[#00f7fc]/20 border border-[#00f7fc]/50 rounded-full px-4 py-2 mb-3" data-id="element-4947" data-mp="2m8f1vyllhnxd">
              <Lock className="w-4 h-4 text-[#00f7fc]" data-id="element-4948" data-mp="kf8qpvcxextu" />
              <span className="text-sm md:text-base font-semibold text-[#00f7fc]" data-id="element-4949" data-mp="kfqs16eg428m">
                Tu lugar está confirmado
              </span>
            </div>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-3 leading-tight tracking-tight" data-id="element-4950" data-mp="28zeizemlg5jv">
            Completa Estos 3 Pasos Importantes
            <br data-id="element-4951" data-mp="2ioekp5shdf1r" />
            <span className="text-[#00f7fc]" data-id="element-4952" data-mp="2ioy46qxs4bhw">Antes De Que Te Vayas</span>
          </h2>
          <p className="text-base md:text-lg text-gray-100 max-w-2xl mx-auto" data-id="element-4953" data-mp="2dxy79lonttfe">
            Para aprovechar al máximo la masterclass
          </p>
          <div className="w-full h-1 bg-gradient-to-r from-transparent via-white to-transparent mt-5" data-id="element-4954" data-mp="2sl13lp18xw15"></div>
        </div>

        {/* Video + WhatsApp CTA Side by Side */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 mb-10 md:mb-14" data-id="element-4955" data-mp="31niqm5oq6sp7">
          {/* Video Section - Left (3 columns) */}
          <div className="lg:col-span-3" data-id="element-4956" data-mp="2wopas6lyuplv">
            <div className="w-full overflow-hidden border border-[#00f7fc]" style={{
            boxShadow: `
                0 0 20px rgba(0, 247, 252, 0.6),
                0 0 40px rgba(0, 247, 252, 0.4),
                0 0 60px rgba(0, 247, 252, 0.3),
                0 0 80px rgba(0, 215, 220, 0.2),
                inset 0 0 20px rgba(0, 247, 252, 0.1)
              `
          }} data-id="element-4957" data-mp="1799c5l5o4ma8">
              <wistia-player media-id="nrxtdp5ht5" aspect="1.7777777777777777" data-id="element-4958" data-mp="3calkybhzpysp"></wistia-player>
            </div>
          </div>

          {/* WhatsApp CTA - Right (2 columns) - PRIORITY #1 */}
          <div className="lg:col-span-2 flex flex-col" data-id="element-4959" data-mp="3g9ufhikuu0pb">
            <div className="bg-gradient-to-br from-[#25D366]/20 to-[#128C7E]/20 border-2 border-[#25D366] rounded-2xl p-5 md:p-6 flex-1 flex flex-col" data-id="element-4960" data-mp="3lah00reo2dy0">
              <div className="bg-[#25D366] rounded-full py-2 px-4 text-center mb-4 inline-block" data-id="element-4961" data-mp="3v138m1nyu477">
                <h3 className="text-base md:text-lg font-bold tracking-tight text-white flex items-center justify-center gap-2" data-id="element-4962" data-mp="3usdem5mzxns">
                  <MessageCircle className="w-5 h-5" data-id="element-4963" data-mp="7x5bqpi20taj" />
                  Paso #1: Únete Al Grupo
                </h3>
              </div>

              <p className="text-sm md:text-base text-gray-200 mb-4 text-center" data-id="element-4964" data-mp="cvq98h5x8yva">
                <span className="font-bold text-[#25D366]" data-id="element-4965" data-mp="1xf2gpfxg17wn">¡IMPORTANTE!</span>{' '}
                Únete ahora al grupo exclusivo de WhatsApp para recibir
                recordatorios y contenido extra.
              </p>

              <a href="https://chat.whatsapp.com/Bt9Hxv3xQbfA0QX5MaAAAL" target="_blank" rel="noopener noreferrer" className="block flex-1 min-h-0" data-id="element-4966" data-mp="1oex8x4oc87hy">
                <div className="relative group h-full" data-id="element-4967" data-mp="2g48seiztkz8y"></div>
              </a>

              <a href="https://chat.whatsapp.com/GDTWSXIrqht4FJw9sIPKI4" target="_blank" rel="noopener noreferrer" className="mt-4 w-full bg-[#25D366] hover:bg-[#128C7E] text-white font-bold py-3 px-6 rounded-full text-center transition-all duration-300 flex items-center justify-center gap-2 shadow-lg hover:shadow-[#25D366]/30" data-id="element-4968" data-mp="2c2nk7ay8d953">
                <MessageCircle className="w-5 h-5" data-id="element-4969" data-mp="2zt1aox162zxk" />
                UNIRME AL GRUPO DE WHATSAPP
              </a>
            </div>
          </div>
        </div>

        {/* Step 2: Exclusive Gift */}
        <div className="mb-6 md:mb-8 max-w-3xl mx-auto" data-id="element-4970" data-mp="23cnah0e4l0vf">
          <div className="bg-gray-700 rounded-full py-3 md:py-4 px-6 md:px-8 text-center mb-4 md:mb-5 inline-block w-full" data-id="element-4971" data-mp="284etmpuyc4bj">
            <h3 className="text-lg md:text-xl font-bold tracking-tight" data-id="element-4972" data-mp="1tga8lf8ffgpl">
              Paso #2: Regalo Exclusivo
            </h3>
          </div>

          <div className="bg-gradient-to-r from-[#00f7fc]/90 to-[#00d7dc]/90 border border-[#00f7fc]/30 rounded-lg p-3 md:p-4 mb-4" data-id="element-4973" data-mp="1yevcppqsukjb">
            <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-4974" data-mp="2r30t60atlndc">
              <Download className="w-4 h-4 md:w-5 md:h-5 text-black" data-id="element-4975" data-mp="2r0wrlp0e90g8" />
              <p className="text-sm md:text-base font-semibold text-black" data-id="element-4976" data-mp="2d2ye0ltwd81s">
                Haz clic en la imagen para descargar la guía
              </p>
            </div>
          </div>

          <div className="mb-5 relative group" data-id="element-4977" data-mp="11njlpvcmv4d0">
            <a href="https://drive.google.com/file/d/1UwCS-6hTXssQIqMUObPKvMnumSsTNm5u/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="block" data-id="element-4978" data-mp="15py4kfgay44a">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-[#00f7fc]/40 to-[#00d7dc]/40 rounded-lg blur-sm opacity-0 group-hover:opacity-100 transition duration-500" data-id="element-4979" data-mp="y4kgrac9to0p"></div>
              <div className="relative" data-id="element-4980" data-mp="1839woxklwyeb">
                <img src="https://cdn.magicpatterns.com/uploads/qGszUSvXKGkMXKzhkKHKP9/heylloyd-image-1769473134106.png" alt="Regalo Gratis - Guía Completa de Implementación" className="w-full max-w-3xl mx-auto rounded-lg border border-[#00f7fc]/50 group-hover:border-[#00f7fc] group-hover:scale-[1.01] transition-all duration-300 cursor-pointer shadow-xl" data-id="element-4981" data-mp="135i7wcf9dsec" />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-black/10 rounded-lg" data-id="element-4982" data-mp="p7a53nvjjwv9">
                  <div className="bg-[#00f7fc]/95 backdrop-blur-sm text-black px-5 py-2.5 rounded-full font-semibold text-base shadow-lg" data-id="element-4983" data-mp="3su0ojklvzgrd">
                    Descargar guía
                  </div>
                </div>
              </div>
            </a>
          </div>

          <p className="text-center text-base md:text-lg leading-normal px-4 text-gray-100" data-id="element-4984" data-mp="1n2tkjbyql80r">
            Antes del workshop, quiero que descargues esta guía y la leas con
            calma.
            <br data-id="element-4985" data-mp="1i5jlr5pgjk09" />
            <br data-id="element-4986" data-mp="1d4vwaogvnb85" />
            Esta guía no es un regalo más. No es un PDF para ejecutar. Y no es
            algo para "aplicar" todavía.
            <br data-id="element-4987" data-mp="186cbire0s5hd" />
            <br data-id="element-4988" data-mp="186u5fhd7m7m4" />
            Su único objetivo es ayudarte a llegar al workshop con el marco
            mental correcto.
            <br data-id="element-4989" data-mp="zd8pvvt80mbn" />
            <br data-id="element-4990" data-mp="zcz82vibxlh1" />
            La mayoría de las personas se equivoca antes de empezar—no porque no
            sepa qué hacer, sino porque empieza por el lugar incorrecto.
            <br data-id="element-4991" data-mp="ucb8hlg1bwb7" />
            <br data-id="element-4992" data-mp="perwks6t7vmf" />
            Esta guía te ayudará a entender el orden correcto para que el
            contenido del workshop tenga sentido desde el primer minuto.
          </p>
        </div>

        {/* Step 3: Check Email */}
        <div className="mb-10 md:mb-14 max-w-3xl mx-auto" data-id="element-4993" data-mp="aazx8i1kwuxc">
          <div className="bg-gray-800/50 border border-gray-700 rounded-xl p-5 md:p-6" data-id="element-4994" data-mp="fb4faci4xxpo">
            <div className="flex items-center gap-3 mb-3" data-id="element-4995" data-mp="fcxonzk4uw1d">
              <div className="bg-yellow-500/20 p-2.5 rounded-full" data-id="element-4996" data-mp="kbiqg3f19nrx">
                <Mail className="w-6 h-6 text-yellow-500" data-id="element-4997" data-mp="p9u0ae5bvya5" />
              </div>
              <h3 className="text-lg md:text-xl font-bold tracking-tight" data-id="element-4998" data-mp="3nqxxcvs47h8u">
                Paso #3: Revisa Tu Email
              </h3>
            </div>
            <p className="text-base text-gray-300" data-id="element-4999" data-mp="3sqspf2nmmcvh">
              Revisa tu bandeja de entrada (y spam) para confirmar tu acceso al
              evento.
            </p>
          </div>
        </div>

        {/* BREAKOUT VIDEOS SECTION */}
        <div className="mb-10 md:mb-14 max-w-5xl mx-auto" data-id="element-5000" data-mp="6c9bf72kczpj">
          <div className="text-center mb-8" data-id="element-5001" data-mp="34zn96mdrxikn">
            <h2 className="text-2xl md:text-3xl font-black mb-3" data-id="element-5002" data-mp="39zjdkmqdvc0q">
              ¿Tienes Dudas?{' '}
              <span className="text-[#00f7fc]" data-id="element-5003" data-mp="31ytsmay8qg3s">Las Resolvemos Aquí:</span>
            </h2>
            <p className="text-gray-400 text-base" data-id="element-5004" data-mp="31wh3ndu2f5h8">
              Mira estos videos cortos para resolver las preguntas más comunes.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-5005" data-mp="3bo3m9v8qg6u0">
            {/* Video 1 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-5006" data-mp="36qbv53fwwoqv">
              <div className="bg-gray-800 relative" data-id="element-5007" data-mp="2j222pio712qr">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-5008" data-mp="2e1o6cxvyfh8k">
                  <iframe src="https://player.vimeo.com/video/1173156247?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 1" data-id="element-5009" data-mp="2szqb3beq28re"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-5010" data-mp="1rnzarieqavn">
                <p className="font-bold text-sm" data-id="element-5011" data-mp="1spmfucp6ntq">
                  ¿Y si HEYLLOYD no funciona para mi nicho o tipo de negocio?
                </p>
              </div>
            </div>

            {/* Video 2 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-5012" data-mp="tjdmt46jrp6c">
              <div className="bg-gray-800 relative" data-id="element-5013" data-mp="yhf1ze0ur4cj">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-5014" data-mp="kr1x5kj9c5rf">
                  <iframe src="https://player.vimeo.com/video/1173156261?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 2" data-id="element-5015" data-mp="oqsw4bixts71"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-5016" data-mp="3fte3rdssffh4">
                <p className="font-bold text-sm" data-id="element-5017" data-mp="3bqhr03pxidl3">
                  Ya he invertido en otros programas y no me funcionaron. ¿Qué
                  hace a este diferente?
                </p>
              </div>
            </div>

            {/* Video 3 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-5018" data-mp="7duboi3us33n">
              <div className="bg-gray-800 relative" data-id="element-5019" data-mp="2if3a5om6zem">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-5020" data-mp="3unsmreccqovs">
                  <iframe src="https://player.vimeo.com/video/1173156277?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VIDEO 3" data-id="element-5021" data-mp="v36u88l2lnim"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-5022" data-mp="2rwhri2gwwyld">
                <p className="font-bold text-sm" data-id="element-5023" data-mp="2rvgcxo0ottyw">
                  No tengo tiempo para implementar otro sistema complejo.
                </p>
              </div>
            </div>

            {/* Video 4 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-5024" data-mp="31mkrimmgbct7">
              <div className="bg-gray-800 relative" data-id="element-5025" data-mp="35ph3vvleecop">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-5026" data-mp="3an8ywyhcaex4">
                  <iframe src="https://player.vimeo.com/video/1173156217?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 4" data-id="element-5027" data-mp="3fm28ifti9ls0"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-5028" data-mp="1u87bvx1m4q3v">
                <p className="font-bold text-sm" data-id="element-5029" data-mp="1u7fgam80msdl">
                  Me preocupa el costo de la inversión. ¿Cuál es el ROI real?
                </p>
              </div>
            </div>

            {/* Video 5 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-5030" data-mp="239ewxdf4bug0">
              <div className="bg-gray-800 relative" data-id="element-5031" data-mp="du7gmzdppomy">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-5032" data-mp="8vdyuure7bgz">
                  <iframe src="https://player.vimeo.com/video/1173156206?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 5" data-id="element-5033" data-mp="2kjitcd8p2wrk"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-5034" data-mp="26oghzal2wf7d">
                <p className="font-bold text-sm" data-id="element-5035" data-mp="1rubute98q76b">
                  ¿No puedo simplemente hacer lo mismo con ChatGPT y otras
                  herramientas gratuitas?
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer data-id="element-5036" data-mp="3r7693x3n0v97" />

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-5037" data-mp="3r4k341weant3">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-5038" data-mp="29ygg22osg7rr">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-5039" data-mp="255wy6tj2iqh5">
              <X className="w-6 h-6" data-id="element-5040" data-mp="1v924cnxqpe97" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-5041" data-mp="1vamzaenyuz7l">
              Términos y Condiciones
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-5042" data-mp="1ra325b3e7vlg">
              <p data-id="element-5043" data-mp="1maq5xzqmtc67">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5044" data-mp="3glvg7mw84mui">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-5045" data-mp="3blqzpwvbfs4a">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5046" data-mp="3sxxk7b6hidhx">
                2. Uso del Servicio
              </h3>
              <p data-id="element-5047" data-mp="1q1v889o0s1p">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5048" data-mp="3a6o8qwd5lenp">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-5049" data-mp="3f5rbga5nv8si">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5050" data-mp="udp8f28lwgeb">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-5051" data-mp="24rr3p3pg3tyj">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5052" data-mp="2ijowg3yund8j">
                5. Modificaciones
              </h3>
              <p data-id="element-5053" data-mp="1lwk9439je3kf">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5054" data-mp="1uvnr13wywcxc">Contacto</h3>
              <p data-id="element-5055" data-mp="1uxqtinfb3yiy">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc]" data-id="element-5056" data-mp="1zse7hscopaja">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-5057" data-mp="3lc9lhsu3zpjs">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-5058" data-mp="3ggu7n0w3ptnd">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-5059" data-mp="37l4svap5rxiy">
              <X className="w-6 h-6" data-id="element-5060" data-mp="32kqgxhkfs3fn" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-5061" data-mp="2xn8gygoecyjs">
              Política de Privacidad
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-5062" data-mp="2sp6zg06md7af">
              <p data-id="element-5063" data-mp="2oowjbup450hu">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5064" data-mp="mvyue9ygis26">
                1. Información que Recopilamos
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-5065" data-mp="2gefll8wvspvn">
                <li data-id="element-5066" data-mp="2l5e6ymwq8e5r">Nombre y dirección de correo electrónico</li>
                <li data-id="element-5067" data-mp="2l6p8sh6m3bu8">Información de registro del evento</li>
                <li data-id="element-5068" data-mp="27eslqrjsvs4p">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5069" data-mp="2bfbdymplv07f">
                2. Uso de la Información
              </h3>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-5070" data-mp="2z68gx9zfan6j">
                <li data-id="element-5071" data-mp="34409853zcbb9">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-5072" data-mp="2q5a90glv5vio">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-5073" data-mp="2q6tv4nu7b0sd">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-5074" data-mp="2v20p33xo4r43">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5075" data-mp="1ep2dv08rhmh1">
                3. Compartir Información
              </h3>
              <p data-id="element-5076" data-mp="1jpzw1ctrugij">
                No se compartirá información móvil con terceros ni afiliados con
                fines de marketing ni promocionales.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5077" data-mp="176kpjnw88340">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-5078" data-mp="1l499mtigz680">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger tu información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5079" data-mp="sg57uj30rdal">
                5. Tus Derechos
              </h3>
              <p data-id="element-5080" data-mp="nj4x3uv85md5">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Contáctanos en:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc]" data-id="element-5081" data-mp="128j631uw21s0">
                  support@truemarketer.com
                </a>
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5082" data-mp="9ocaydktx7xl">6. Cookies</h3>
              <p data-id="element-5083" data-mp="4qswbck7yt54">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-5084" data-mp="393wjdtzzif5l">Contacto</h3>
              <p data-id="element-5085" data-mp="3d61ekx62zjuc">
                Para preguntas:{' '}
                <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc]" data-id="element-5086" data-mp="3d4gk17jro0wh">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Floating WhatsApp Button */}
      <WhatsAppButton data-id="element-5087" data-mp="3ru4js4cauri3" />
    </div>;
}